import { useTranslation } from "react-i18next";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { formatNumber } from "utils/utils";
import {
  DistributionActions,
  DistributionFooter,
  DistributionTotalText,
  DistributionTotals,
} from "./tips.distributionModal.styled";
import type { DistributionMode } from "./tips.distributionModal.types";

interface TipsDistributionFooterProps {
  readonly canUndoDistribution: boolean;
  readonly distributionMode: DistributionMode;
  readonly isLockDistributionDisabled: boolean;
  readonly isSaving: boolean;
  readonly percentageLeftToSplit: number;
  readonly remainingAmount: number;
  readonly totalTipsAmount: number;
  readonly onClose: () => void;
  readonly onLockDistribution: () => void;
  readonly onUndoDistribution: () => void;
}

export const TipsDistributionFooter = (
  props: TipsDistributionFooterProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <DistributionFooter>
      <DistributionTotals>
        <DistributionTotalText>
          {props.distributionMode === "team"
            ? t("Tips.PercentageLeftToSplit", {
                percentage: props.percentageLeftToSplit,
              })
            : t("Tips.AmountLeftToSplit", {
                amount: formatNumber(props.remainingAmount),
                currency: t("Tips.Currency"),
              })}
        </DistributionTotalText>
        <DistributionTotalText>
          {t("Tips.TotalTips", {
            amount: formatNumber(props.totalTipsAmount),
            currency: t("Tips.Currency"),
          })}
        </DistributionTotalText>
      </DistributionTotals>
      <DistributionActions>
        <SecondaryButton
          label={t("Tips.Cancel")}
          onClick={props.onClose}
          size="small"
          type="button"
        />
        {props.canUndoDistribution && (
          <SecondaryButton
            iconName="v2/reset"
            label={t("Tips.UndoDistribution")}
            onClick={props.onUndoDistribution}
            size="small"
            type="button"
          />
        )}
        <PrimaryButton
          disabled={props.isLockDistributionDisabled}
          isLoading={props.isSaving}
          label={t("Tips.LockDistribution")}
          onClick={props.onLockDistribution}
          size="small"
          type="button"
        />
      </DistributionActions>
    </DistributionFooter>
  );
};
